import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom"; // URL에서 musicianId 가져오기
import { collection, getDocs } from "firebase/firestore"; // Firestore
import { db } from "../../../firebase"; // Firestore 초기화

import Loading from "../../Loading";
import styleClasses from "../css/mobile/Members.module.scss";

const Members = () => {
  const { id: musicianId } = useParams(); // URL에서 musicianId 가져오기
  const [members, setMembers] = useState([]); // 멤버 데이터 상태
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태

  // Firestore에서 멤버 데이터 가져오기
  const fetchMembers = async (musicianId) => {
    try {
      const membersRef = collection(db, "musicians", musicianId, "members");
      const membersSnapshot = await getDocs(membersRef);

      const fetchedMembers = membersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMembers(fetchedMembers);
    } catch (error) {
      console.error("Error fetching members:", error);
    } finally {
      setIsLoading(false); // 로딩 완료
    }
  };

  useEffect(() => {
    if (musicianId) {
      fetchMembers(musicianId);
    }
  }, [musicianId]);

  return isLoading ? (
    <Loading /> // 로딩 상태 처리
  ) : members.length > 0 ? (
    <div className={`${styleClasses.membersMobilePage} members`}> {/* ✅ className 추가 */}
      <div className={styleClasses.gridContainer}>
        {members.map((member) => (
          <div key={ member.id } className={ styleClasses.memberCard }>
            <div className={ styleClasses.textBox }>
              <h3 className={ styleClasses.positionTitle }>
                <Link to={ member.link } target="_blank" rel="noopener noreferrer">
                  { member.position }
                </Link>
              </h3>
              <h4 className={ styleClasses.memberName }>
                <Link to={ member.link } target="_blank" rel="noopener noreferrer">
                  { member.name }
                </Link>
              </h4>
              <p className={ styleClasses.memberDescription }>
                <Link to={ member.link } target="_blank" rel="noopener noreferrer">
                  { member.description }
                </Link>
              </p>
              {/* ✅ SNS Links 추가 */}
              {member.sns && (
                <div className={styleClasses.snsLinks}>
                  {Object.entries(member.sns).map(([platform, url]) => (
                    <Link key={platform} to={url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={`/assets/icons/${platform}-icon_1.png`}
                        alt={platform}
                      />
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div className={ styleClasses.imageBox }>
              <Link to={ member.link } target="_blank" rel="noopener noreferrer">
                <img src={ member.image } alt={ member.name } className={ styleClasses.memberImage } />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <p className={styleClasses.noData}>No members found.</p> // 데이터가 없을 경우
  );
};

export default Members;